export default function disableImageRightClick() {
  document.querySelectorAll("img").forEach((item) => {
    item.addEventListener("contextmenu", (element) => {
      element.preventDefault();
    });
  });
}
